import { render } from "./BaseContainer.vue?vue&type=template&id=c6d65ebc&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"

import "./BaseContainer.vue?vue&type=style&index=0&id=c6d65ebc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d65ebc"]])

export default __exports__